import BaseService from "./BaseService";

export default class AdminService extends BaseService {
  static endPoint = "auth/login";
}
